export const CODICE_EVENTO = "codEvento";
export const ID_OSPEDALE = "idPs";
export const STATO = "stato";
export const CODICE_COLORE = "codiceColore";
export const TIMESTAMP_TRIAGE = "timpestampTriage";
export const INIZIALI_PAZIENTE = "iniziali";
export const LUOGO = "luogo";
export const PRESTAZIONI = "prestazioni";
export const CODICE_DIALOG = "codiceDialog";
export const ARGOMENTI_STATO_O_DIALOG = "argomentiStatoODialog";
export const CODICE_MESSAGGIO = "codiceMessaggio";
export const LAST_EVENT = "lastEvent";
export const LAST_UPDATE_TIMESTAMP = "lastUpdate";
export const FINE_EPISODIO_TIMESTAMP = "timestampFineEpisodio";
export const LAST_UPDATE_FORMAT = "DD/MM/YYYY - HH:mm:ss";
export const NOTIFICATIONS_TIMESTAMP_FORMAT = "HH:mm:ss";
export const FINE_EPISODIO_TIMESTAMP_DATE_FORMAT = "DD/MM/YYYY";
export const FINE_EPISODIO_TIMESTAMP_TIME_FORMAT = "HH:mm:ss";

export const PREFIX_STATO_PAZIENTE = "ld.monitoraggio.stato.";
export const PREFIX_DIALOG = "ld.monitoraggio.dialog.";
export const PREFIX_MESSAGGIO = "ld.monitoraggio.messaggio.";

// Parametro che uso per gestire la refresh della pagina di monitoraggio
export const IS_NAVIGATION_FROM_FORM = "isNavigationFromForm";
export const EVENT_COMPLETED = "eventoPsTerminato";
export const SUBSCRIBE_EVENT = "subscribe";
export const UNSUBSCRIBE_EVENT = "unsubscribe";

// Oggetto prestazione tornato da servizio
export const PREFIX_LABEL_PRESTAZIONE = "ld.monitoraggio.prestazioni.";
export const PREFIX_STATO_PRESTAZIONE = "ld.monitoraggio.prestazioni.stato.";
export const ID_PRESTAZIONE = "resId";
export const TIPOLOGIA_PRESTAZIONE = "code";
export const ORDINE_PRESTAZIONE = "index";
export const STATO_PRESTAZIONE = "status";

// ID tag html delle varie sezioni dell'header di monitoraggio
export const PS_CHANGED = "prontoSoccorsoChanged";
export const STATO_PAZIENTE_CHANGED = "statoPazienteChanged";
export const CODICE_COLORE_CHANGED = "codiceEmergenzaChanged";
export const POSIZIONE_CHANGED = "posizioneBoxChanged";
export const PRESTAZIONI_CHANGED = "prestazioniBoxChanged";

// ID ospedali
export const ID_OSPEDALE_SAN_MARTINO = "07090100"; // HSM
export const ID_OSPEDALE_GASLINI = "07094000"; // Gaslini
export const ID_OSPEDALE_GALLIERA = "07002500"; // Galliera,
export const ID_OSPEDALE_EVANGELICO = "07005102"; // Ospedale Evangelico

export const ID_OSPEDALE_IMPERIA = "07000101"; // ASL1
export const ID_OSPEDALE_SANREMO = "07000102"; // ASL1
export const ID_OSPEDALE_BORDIGHERA = "07000103"; // ASL1

export const ID_OSPEDALE_ALBENGA = "07021101"; // ASL2
export const ID_OSPEDALE_SANTA_CORONA = "07021102"; // ASL2
export const ID_OSPEDALE_CAIRO = "07021203"; // ASL2
export const ID_OSPEDALE_SAVONA = "07021204"; // ASL2

export const ID_OSPEDALE_SESTRI = "07030103"; // ASL3
export const ID_OSPEDALE_VILLA_SCASSI = "07030104"; // ASL3
export const ID_OSPEDALE_PONTEDECIMO = "07030105"; // ASL3

export const ID_OSPEDALE_LAVAGNA = "07003901"; // ASL4

export const ID_OSPEDALE_LA_SPEZIA = "07005801"; // ASL5
export const ID_OSPEDALE_LEVANTO = "07005803"; // ASL5
export const ID_OSPEDALE_SARZANA = "07005804"; // ASL5
